import React from "react";
import { withRouter } from "react-router-dom";
import { ExploreForm } from "./ExploreForm";
import { useSelector } from "react-redux";
import { ExploreCrad } from "./ExploreCrad";

const ExploreLayout = () => {
  const { exploreList } = useSelector((state) => state.exploreReducer);
  const exploreService = exploreList?.svc_typ_desc
  const explorelist = exploreList.usr?.rec || [];
  return <div>{explorelist.length > 0 ? <ExploreCrad exploreList={explorelist} exploreService={exploreService} /> : <ExploreForm />}</div>;
};
export default withRouter(ExploreLayout);
